import { StyleColor } from '../../utils/styles-constants';
import { styled, component, spin } from '../../utils/style';

const loader = `
	cursor: default;
	display: flex;
	align-items: center;
	justify-content: center;

	& > :last-child {
		margin: 0 5px;
	}

	& > svg {
		position: relative;
		animation: ${spin} 2s linear infinite;
	}
`;

interface LoaderProps {
	isDownloadingAll: boolean;
}

const LoaderVariants: ({}) = {
	['Button']: styled<LoaderProps>()(component.div, 'StyledLoader') `
		${loader}
		& > svg {
			height: 25px;
			width: 25px;
			margin-left: ${props => props.isDownloadingAll ? `-25px` : `0`};
			margin-right: ${props => props.isDownloadingAll ? `15px` : `5px`};
		}
	`,
	['Overlay']: styled()(component.div, 'StyledLoader')`
		${loader}
		background: ${StyleColor.White};
		color: ${StyleColor.Black};
		opacity: 0.9;
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 1;

		& > svg {
			height: 30px;
			width: 30px;
			margin-right: 5px;
		}
	`
};

export { LoaderVariants };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/styles.ts